



















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { namespace } from 'vuex-class'
const orders = namespace('orders')

@Component
export default class OrdersCrumb extends Vue {
    @Prop() readonly route!: Route
    @Prop() readonly last!: boolean
    @orders.Getter activeView: string
    @orders.Getter activeDirection: string

    get componentClasses(): object {
        return {
            'crumb': true,
            'crumb--last': this.last,
        }
    }

    get view(): string {
        return this.activeView || 'user'
    }

    get direction(): string {
        return this.activeDirection || 'in'
    }
}

